/**
 * @file URL変換
 */
'use strict';
// utility class


/**
 * @classname CheckUrlView
 * @classdesc URL変換
 */
export default class CheckUrlView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('CheckUrlView.constructor');
		let text = $e.html();
		text = text.replace(/(http(s)?:\/\/[a-zA-Z0-9-_.!'()*;/?:@&=+$,%#]+)/gi, "<a href='$1' target='_blank'>$1</a>");
		$e.html(text);
	};
}
